import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

export type ChipType = "geojson" | "json" | "text" | "image" | "binary" | "raster" | "url" | "error" | "warn" | "count";

const DEFAULT_LABELS: Record<ChipType, string> = {
  geojson: "GEOJSON",
  json: "JSON",
  text: "TEXT",
  image: "IMAGE",
  binary: "BINARY",
  raster: "GEOTIFF",
  url: "URL",
  error: "Error",
  warn: "Incomplete",
  count: "",
};

/**
 * Semantic type badge for AI block cards.
 * Applies color roles per type via host CSS class (chip-{type}).
 */
@Component({
  selector: "app-type-chip",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  template: `
    @if (icon()) {
    <mat-icon>{{ icon() }}</mat-icon>
    }
    {{ displayLabel() }}
  `,
  styleUrl: "./type-chip.component.scss",
  host: { "[class]": "chipClass()" },
})
export class TypeChipComponent {
  type = input.required<ChipType>();

  label = input<string>();

  icon = input<string | null>(null);

  protected readonly displayLabel = computed(() => this.label() ?? DEFAULT_LABELS[this.type()]);

  protected readonly chipClass = computed(() => `chip-${this.type()}`);
}
